<div class="row footer">
    <div class="col-md-4">
        
    </div>
    <div class="col-md-4">
        <p class="copyright" style="color: #1a9950 !important; font-size: 13px;
        margin-top: 13px;">PG App Version 1.0</p>
    </div>
    <div class="col-md-4">
        
    </div>
</div>